export const ROUTE_HUB = 'Coimbatore';

/**
 * Business-supplied Coimbatore route catalogue.
 * Destination labels identify which landing pages exist.
 * Kilometre values are catalogue metadata only — they are not the fare-distance source.
 * Live Google Distance Matrix distance is used for display and fare estimates.
 */
export const COIMBATORE_ROUTE_MASTER = [
  { destination: 'Chennai', distanceKm: 494 },
  { destination: 'Vellore', distanceKm: 388 },
  { destination: 'Tiruvannamalai', distanceKm: 317 },
  { destination: 'Pondychery', distanceKm: 378 },
  { destination: 'Nagarkovil', distanceKm: 448 },
  { destination: 'Thiruchendur', distanceKm: 398 },
  { destination: 'Ramanathapuram', distanceKm: 344 },
  { destination: 'Rameshwaram', distanceKm: 402 },
  { destination: 'Tenkasi', distanceKm: 375 },
  { destination: 'Thoothukudi', distanceKm: 367 },
  { destination: 'kaniyakumari', distanceKm: 447 },
  { destination: 'Thirunelveli', distanceKm: 364 },
  { destination: 'Bangalore', distanceKm: 343 },
  { destination: 'Hosur', distanceKm: 310 },
  { destination: 'Thanjavur', distanceKm: 315 },
  { destination: 'Villupuram', distanceKm: 343 },
  { destination: 'Ambur', distanceKm: 341 },
  { destination: 'Cuddalore', distanceKm: 364 },
  { destination: 'Nagapatinam', distanceKm: 397 },
  { destination: 'Vellankanni', distanceKm: 405 },
  { destination: 'Karaikal', distanceKm: 410 },
  { destination: 'Trivandrum', distanceKm: 380 },
  { destination: 'Tripati', distanceKm: 450 },
  { destination: 'Arani', distanceKm: 354 },
  { destination: 'Thiruvarur', distanceKm: 372 },
  { destination: 'Mannarkudi', distanceKm: 330 },
  { destination: 'Kumbakonam', distanceKm: 300 },
];

/** Exact names from the existing homepage city list. */
export const SERVICE_CITY_NAMES = new Set([
  'Ambur',
  'Arani',
  'Bangalore',
  'Chennai',
  'Coimbatore',
  'Cuddalore',
  'Hosur',
  'Karaikal',
  'Kumbakonam',
  'Mannarkudi',
  'Ramanathapuram',
  'Thanjavur',
  'Thiruchendur',
  'Thiruvarur',
  'Thiruvannamalai',
  'Trivandrum',
  'Vellore',
  'Villupuram',
]);
